import { db } from "../firebaseConfig";
import { collection, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, orderBy, query, getDocs, limit, startAfter } from "firebase/firestore";

export async function addBrand(data) {
  const payload = {
    name: data.name,
    slug: (data.slug || data.name || "").toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,''),
    logo: data.logo || "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };
  const ref = await addDoc(collection(db, "brands"), payload);
  return ref.id;
}

export async function updateBrand(id, patch) {
  await updateDoc(doc(db, "brands", id), { ...patch, updatedAt: serverTimestamp() });
}

export async function deleteBrand(id) {
  await deleteDoc(doc(db, "brands", id));
}

export async function listBrands({ pageSize = 50, cursor = null } = {}) {
  let q = query(collection(db, "brands"), orderBy("createdAt", "desc"), limit(pageSize));
  if (cursor) q = query(q, startAfter(cursor));
  const snap = await getDocs(q);
  const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
  const nextCursor = snap.docs.at(-1) || null;
  return { items, nextCursor };
}
